import { Typography } from "@mui/material";
import { FC } from "react";

interface AverageSpeedColumnProps {
  averageSpeed: number | undefined;
}

const AverageSpeedColumn: FC<AverageSpeedColumnProps> = ({ averageSpeed }) => {
  return <Typography>{(averageSpeed ?? "-").toString().replace(".", ",")} m/s</Typography>;
};

export default AverageSpeedColumn;
